import angular from 'angular';

// Libraries
import uiModal from 'angular-ui-bootstrap/src/modal';

// Controller
import AppVersionUpdateCompleteController from './appVersionUpdateCompleteModal.controller';
import template from './appVersionUpdateCompleteModal.html';

const moduleName = 'recaps.editor.modals.appVersionUpdateComplete';
let module = angular.module(moduleName, [
  uiModal,
]);

module.controller('AppVersionUpdateCompleteController', AppVersionUpdateCompleteController);
module.factory('showAppVersionUpdateCompleteModal', ['$uibModal', ($uibModal) => {
  return props => {
    props = props || {};
    let modal = $uibModal.open({
      template: template,
      controller: AppVersionUpdateCompleteController,
      controllerAs: 'vm',
      size: props.size || 'sm',
      resolve: {
        message: () => props.message || props,
        title: () => props.title || '',
      }
    });
    return modal.result;
  };
}]);

export default module;
